<script>
    import { ISSUE_PAYLOAD_TYPE } from '@/constants';
    import AutomaticInformPayloadModal from '@/views/Issues/Payloads/AutomaticInformPayloadModal.vue';

    export default {
        name: 'AutomaticInformPayload',
        components: {
            AutomaticInformPayloadModal,
        },
        props: {
            payload: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            isModalVisible: false,
        }),
        computed: {
            labelText() {
                return {
                    [ISSUE_PAYLOAD_TYPE.IN_FORM]: this.$t('Issue raised manually from inspection'),
                    [ISSUE_PAYLOAD_TYPE.AUTOMATIC]: this.$t('Issue raised automatically from inspection'),
                }[this.payload.type] || this.$t('Issue raised manually from inspection');
            },
        },
    };
</script>

<template>
    <div>
        <p>{{ labelText }}</p>
        <button class="btn text-primary btn-link mt-2" type="button" @click="isModalVisible = true">
            {{ $t('View check item') }}
        </button>

        <portal to="modals">
            <AutomaticInformPayloadModal
                v-if="isModalVisible"
                :payload="payload"
                @close="isModalVisible = false"
            />
        </portal>
    </div>
</template>
